export class UpdateCoverImageModel {
  public content!: File;
}
